import { useIndustry } from './use-industry';
import { usePlatformModules } from './use-modules';

/**
 * Returns true when the current org should see invoicing UI
 * (invoices pages, bids, billing-type fields, etc.).
 *
 * Facility-type orgs manage internal work and never invoice external
 * clients, so invoicing is hidden even when H3Books is enabled.
 */
export function useShowInvoicing(): boolean {
  const { industry } = useIndustry();
  const { isModuleEnabled } = usePlatformModules();
  return isModuleEnabled('projects') && industry !== 'facility_ops';
}
